export const i18n = {
  en: {
    select_all_collections: "Select all datasets",
    deselect_all_collections: "Deselect all datasets",
    request: "Request",
    close: "Close",
    home: "Back to the catalogue",
    view: "View",
    email: "Email",
    add: "Add",
    add_all: "Add all",
    remove: "Remove",
    remove_all: "Remove all",
    send_to_negotiator: "Send to the Negotiator",
    send_to_podium: "Send to Podium",
    card_biobank_details: "About this dataset series",
    card_collections_details: "View datasets within the series",
    match_option1: "Match all",
    match_option2: "Match any",
    filter_loading: "Loading filters",
    select_all: "Select all",
    deselect_all: "Deselect all",
    biobank_withdrawn: "This dataset series is no longer part of EUCAIM",
    collection_withdrawn:
      "This dataset belongs to a series that is no longer part of EUCAIM",
  },
};
